// extracted by mini-css-extract-plugin
export default {"title":"DaysUsage_title_dTPgZ","column2":"DaysUsage_column2_JEAef","column3":"DaysUsage_column3_wg1bt","maxedOut":"DaysUsage_maxedOut_W6VrR"};